(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ct-spotted-wild"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-ct-spotted]');

    roots.forEach((root) => {
      if (root.dataset.ctSpotBound === 'true') return;
      root.dataset.ctSpotBound = 'true';

      const track = root.querySelector('[data-ct-spot-track]');
      const nav = root.querySelector('[data-ct-spot-nav]');
      const prev = root.querySelector('[data-ct-spot-prev]');
      const next = root.querySelector('[data-ct-spot-next]');

      if (track && prev && next && nav) {
        const getStep = () => {
          const card = track.querySelector('.ct-spot__card');
          if (!card) return 300;
          const styles = getComputedStyle(track);
          const gap = parseFloat(styles.columnGap || styles.gap) || 20;
          return card.getBoundingClientRect().width + gap;
        };

        const updateNav = () => {
          const max = Math.max(0, track.scrollWidth - track.clientWidth);
          const hasOverflow = max > 4;
          nav.hidden = !hasOverflow;
          prev.disabled = !hasOverflow || track.scrollLeft <= 2;
          next.disabled = !hasOverflow || track.scrollLeft >= max - 2;
        };

        prev.addEventListener('click', () => {
          track.scrollBy({ left: -getStep(), behavior: 'smooth' });
        });

        next.addEventListener('click', () => {
          track.scrollBy({ left: getStep(), behavior: 'smooth' });
        });

        track.addEventListener('scroll', updateNav, { passive: true });
        window.addEventListener('resize', updateNav, { passive: true });

        if (typeof ResizeObserver !== 'undefined') {
          new ResizeObserver(updateNav).observe(track);
        }

        updateNav();
        requestAnimationFrame(updateNav);
      }

      const dialog = root.querySelector('[data-ct-spot-dialog]');
      const stage = root.querySelector('[data-ct-spot-stage]');
      const closeBtn = root.querySelector('[data-ct-spot-close]');
      if (!dialog || !stage) return;

      const clearStage = () => {
        const video = stage.querySelector('video');
        if (video) {
          video.pause();
          video.removeAttribute('src');
          video.load?.();
        }
        stage.replaceChildren();
      };

      const closeDialog = () => {
        clearStage();
        if (typeof dialog.close === 'function') dialog.close();
      };

      const openFromButton = (btn) => {
        if (btn.getAttribute('data-has-video') !== 'true') return;

        clearStage();
        const type = btn.dataset.videoType;

        if (type === 'shopify') {
          const tpl = document.getElementById(btn.dataset.videoId || '');
          if (!tpl) return;
          stage.appendChild(tpl.content.cloneNode(true));
          const video = stage.querySelector('video');
          if (video) {
            video.controls = true;
            video.playsInline = true;
            video.play?.().catch(() => {});
          }
        } else if (type === 'url') {
          const url = btn.dataset.videoUrl || '';
          if (!url) return;

          const yt = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/))([A-Za-z0-9_-]{6,})/);
          const vimeo = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);

          if (yt) {
            const iframe = document.createElement('iframe');
            iframe.src = `https://www.youtube.com/embed/${yt[1]}?autoplay=1&rel=0`;
            iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
            iframe.allowFullscreen = true;
            iframe.title = 'YouTube video';
            stage.appendChild(iframe);
          } else if (vimeo) {
            const iframe = document.createElement('iframe');
            iframe.src = `https://player.vimeo.com/video/${vimeo[1]}?autoplay=1`;
            iframe.allow = 'autoplay; fullscreen; picture-in-picture';
            iframe.allowFullscreen = true;
            iframe.title = 'Vimeo video';
            stage.appendChild(iframe);
          } else {
            const video = document.createElement('video');
            video.className = 'ct-spot__player-video';
            video.src = url;
            video.controls = true;
            video.playsInline = true;
            video.autoplay = true;
            stage.appendChild(video);
            video.play?.().catch(() => {});
          }
        }

        if (typeof dialog.showModal === 'function') dialog.showModal();
      };

      root.addEventListener('click', (event) => {
        const openBtn = event.target.closest('[data-ct-spot-open]');
        if (openBtn && root.contains(openBtn)) {
          event.preventDefault();
          openFromButton(openBtn);
          return;
        }

        if (event.target.closest('[data-ct-spot-close]')) {
          closeDialog();
        }
      });

      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) closeDialog();
      });

      dialog.addEventListener('close', clearStage);

      closeBtn?.addEventListener('click', closeDialog);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
